import { makeStyles } from '@mui/styles';
import { display } from '@mui/system';

export const useStylesEditPage = makeStyles((theme: any) => ({
  card: {
    marginTop: theme.spacing(3),
  },
  actions: {
    marginTop: theme.spacing(3),
  },
  buttons: {
    marginRight: theme.spacing(2),
  },
  btnDel: {
    // marginLeft: theme.spacing(2),
  },
  delButton: {
    marginLeft: theme.spacing(2),
  },
  switch: {
    marginLeft: theme.spacing(1),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  companyBox: {},
  companyTitle: {},
  companyField: {
    display: 'flex',
    alignItems: 'center',
  },
  allCompaniesBtn: {
    marginTop: 8,
    marginLeft: 10,
    height: 52,
  },
  dates: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down(470)]: {
      flexDirection: 'column',
    },
  },
  country: {
    marginRight: 5,
    [theme.breakpoints.down(470)]: {
      marginRight: 0,
    },
  },
  userAcitons: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    width: '100%',
    [theme.breakpoints.down(1024)]: {
      maxWidth: 880,
    },
  },
  showIfMobile: {
    display: 'none !important',
    [theme.breakpoints.down(1024)]: {
      display: 'inline !important',
    },
  },
  hideIfMobile: {
    [theme.breakpoints.down(1024)]: {
      display: 'none !important',
    },
  },
}));
